import { MessageFilled } from "@ant-design/icons";
import { FC, useCallback } from "react";
import { TaskEntityBase, TaskStatus } from "tm-shared/types";

import { StatusCycleButton } from "@/components/CycleButton";
import FlexContainer from "@/components/FlexContainer";
import { StatusIndicator } from "@/components/Status/StatusIndicator";
import { PrimaryText } from "@/components/Typography/Styled";

import { StyledCommentIndicator, StyledTaskProductsMatrix } from "./Styled";

interface ProductsMatrixTaskProps {
    name: string;
    barcode: string;
    isActive: boolean;
    onChangeActive: (id: string) => void;
    onChangeStatus: (status: TaskStatus, barcode: string) => void;
    payload: TaskEntityBase | undefined;
}

export const ProductsMatrixTask: FC<ProductsMatrixTaskProps> = ({
    name,
    barcode,
    isActive,
    onChangeActive,
    onChangeStatus,
    payload,
}) => {
    const hasComment = !!payload?.comment;
    const status = payload?.status ?? TaskStatus.Incomplete;

    const handleSelectTask = useCallback(() => {
        onChangeActive(barcode);
    }, [barcode]);

    const handleChangeStatus = useCallback(
        (status: TaskStatus) => {
            onChangeStatus(status, barcode);
        },
        [barcode],
    );

    return (
        <StyledTaskProductsMatrix
            $isActive={isActive}
            onClick={handleSelectTask}
        >
            <PrimaryText>
                {name} ({barcode})
            </PrimaryText>

            <FlexContainer>
                <StyledCommentIndicator>
                    {hasComment && (
                        <StatusIndicator type="warning">
                            <MessageFilled />
                        </StatusIndicator>
                    )}
                </StyledCommentIndicator>

                <StatusCycleButton
                    value={status}
                    onChange={handleChangeStatus}
                    dimension={48}
                    border={false}
                />
            </FlexContainer>
        </StyledTaskProductsMatrix>
    );
};
